if (!window.ShopifyProductManagerDefined) {
  window.ShopifyProductManagerDefined = true;

  function safeForEach(collection, callback) {
    if (!collection || !collection.forEach) return;
    try {
      collection.forEach(callback);
    } catch (error) {
    }
  }

  class ShopifyProductManager {
    constructor(container = document) {
      this.container = container;
      this.variants = this.getProductVariants();
      this.variant = null;
      this.swipers = { main: null, thumbs: null };
      this.isInitialLoad = true;
      this.isMainProductPage = this.checkIfMainProductPage();

      this.elements = {
        variantsJson: container.querySelector('[id^="product-variants-json"]'),
        addToCartBtn: container.querySelector('.add-to-cart'),
        qtyInput: container.querySelector('.product-qty-input'),
        inventoryEl: container.querySelector('.product-inventory'),
        priceEl: container.querySelector('.price'),
        galleryContainer: container.querySelector('.product-gallery'),
        galleryMain: container.querySelector('.product-gallery__main'),
        galleryThumbs: container.querySelector('.product-gallery__thumbs.swiper'),
        form: container.querySelector('form[action*="/cart/add"]'),
        variantInput: container.querySelector('input[name="id"]')
      };
      this.cartType = document.body.dataset.cartType || 'drawer';
      
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.init();
          observer.unobserve(this.container);
        }
      }, { rootMargin: '200px' });
      observer.observe(this.container);
    }

    getProductVariants() {
      const variantsJson = this.container.querySelector('[id^="product-variants-json"]');
      if (variantsJson) {
        try {
          return JSON.parse(variantsJson.textContent);
        } catch (e) {
        }
      }
      return window.productVariants || [];
    }

    checkIfMainProductPage() {
      const bodyClasses = document.body.className;
      if (bodyClasses.includes('template-product')) {
        return true;
      }

      const urlPath = window.location.pathname;
      if (urlPath.includes('/products/') && !urlPath.includes('/collections/')) {
        return true;
      }

      return false;
    }

    openCartDrawer() {
      const drawerElement = document.querySelector('.cart-drawer-wrap');
      if (drawerElement) {
        drawerElement.classList.add('active');
        document.body.classList.add('drawer-open');
      }
      if (window.ajaxCart && typeof window.ajaxCart.updateCartDrawerContent === 'function') {
        window.ajaxCart.updateCartDrawerContent();
      }
    }

    init(initialIndex = 0) {
      if (typeof Swiper !== 'undefined') {
        this.initGallery(initialIndex);
      }
      this.setupQuantityControls();
      this.initZoom();

      if (this.variants && this.variants.length > 0) {
        this.setupEventListeners();
        this.loadVariantFromURL();
        const variant = this.getvariant();

        if (variant) {
          this.variant = variant;
          this.updatePrice(variant);
          this.updateInventory(variant);
          this.updateAddToCartButton(variant);

          if (this.isInitialLoad) {
            const galleryVariant = this.getVariantForGallery();
            if (galleryVariant) {
              this.updateGalleryForVariant(galleryVariant, true);
            }
          }
        } else {
          const defaultVariant = this.selectDefaultVariant();
          if (defaultVariant) {
            this.variant = defaultVariant;
            this.updatePrice(defaultVariant);
            this.updateInventory(defaultVariant);
            this.updateAddToCartButton(defaultVariant);

            if (this.isInitialLoad) {
              const galleryVariant = this.getVariantForGallery();
              if (galleryVariant) {
                this.updateGalleryForVariant(galleryVariant, true);
              }
            }
          } else {
            this.updateInventoryNoVariant();
            this.updateAddToCartButtonNoVariant();
          }
        }

        this.updateVariantAvailability();
      } else {
        this.setupEventListeners();
        const addToCartBtn = this.elements.addToCartBtn;
        if (addToCartBtn) {
          const variantsJson = this.container.querySelector('[id^="product-variants-json"]');
          if (variantsJson) {
            try {
              const productData = JSON.parse(variantsJson.textContent);
              if (productData.length > 0 && !productData[0].available) {
                addToCartBtn.classList.add('sold-out');
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = window.productStrings?.soldOut || 'Sold Out';
              }
            } catch (e) {
            }
          }
        }
      }
    }

    setupEventListeners() {
      if (this.boundHandleChange) {
        this.container.removeEventListener('change', this.boundHandleChange);
      }
      if (this.boundHandleClick) {
        this.container.removeEventListener('click', this.boundHandleClick);
      }

      this.boundHandleChange = this.handleChange.bind(this);
      this.boundHandleClick = this.handleClick.bind(this);

      this.container.addEventListener('change', this.boundHandleChange);
      this.container.addEventListener('click', this.boundHandleClick);

      const forms = this.container.querySelectorAll('form[action*="/cart/add"]');
      forms.forEach(form => {
        if (form === this.elements.form) {
          if (this.boundHandleSubmit) {
            this.elements.form.removeEventListener('submit', this.boundHandleSubmit);
          }
          this.boundHandleSubmit = this.handleSubmit.bind(this);
          this.elements.form.addEventListener('submit', this.boundHandleSubmit);
        }
      });
    }

    handleChange(event) {
      if (event.target && event.target.matches('.product-variant-value-input')) {
        this.isInitialLoad = false;
        this.handleVariantInputChange(event.target);
        this.updateVariantState();
      }
      if (event.target && event.target.matches('.variant-dropdown')) {
        this.isInitialLoad = false;
        this.handleVariantDropdownChange(event.target);
        this.updateVariantState();
      }
    }

    handleClick(event) {
      if (event.target && event.target.closest('.product-other-colors')) {
        return;
      }

      if (event.target && event.target.closest('.product-variant-value-label')) {
        const label = event.target.closest('.product-variant-value-label');
        if (label.tagName === 'A') return;

        const input = label.querySelector('.product-variant-value-input');
        if (input && !input.disabled) {
          this.isInitialLoad = false;
          this.updateCheckedStates(input);
          this.updateVariantState();
        }
      }
    }

    async handleSubmit(e) {
      if (e.defaultPrevented) {
        return;
      }

      const recipientForm = this.elements.form?.querySelector('recipient-form');
      if (recipientForm && typeof recipientForm.checkValidation === 'function') {
        const isValid = recipientForm.checkValidation();
        if (!isValid) {
          e.preventDefault();
          return;
        }
      }

      e.preventDefault();

      if (!this.variant) {
        alert(window.productStrings?.selectVariant || 'Please select an available variant.');
        return;
      }

      if (!this.variant.available) {
        this.handleErrorMessage(window.productStrings?.variantSoldOut || 'Selected variant is sold out.');
        return;
      }

      const sellingPlanInput = this.elements.form.querySelector('[name="selling_plan"]');
      const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : '';

      if (this.variant.requires_selling_plan && !sellingPlanId) {
        if (window.ajaxCart && typeof window.ajaxCart.showError === 'function') {
          window.ajaxCart.showError(window.productStrings?.sellingPlanRequired || 'Variant can only be purchased with a selling plan');
        } else {
          this.handleErrorMessage(window.productStrings?.sellingPlanRequired || 'Variant can only be purchased with a selling plan');
        }
        return;
      }

      if (this.elements.variantInput) {
        this.elements.variantInput.value = this.variant.id;
      }

      this.handleErrorMessage();

      const formData = {
        id: this.variant.id,
        quantity: parseInt(this.elements.qtyInput?.value || 1),
        selling_plan: sellingPlanId || undefined,
        inventory_quantity: this.variant.inventory_quantity,
        inventory_management: this.variant.inventory_management,
        inventory_policy: this.variant.inventory_policy,
        min_purchase_quantity: this.variant.min_purchase_quantity,
        max_purchase_quantity: this.variant.max_purchase_quantity
      };

      if (window.ajaxCart && typeof window.ajaxCart.addToCart === 'function') {
        const result = await window.ajaxCart.addToCart(formData, true);

        if (result && result.error) {
          this.handleErrorMessage(result.message);

          if (result.inventoryExceeded || (result.message && result.message.includes('maximum quantity'))) {
            if (window.ajaxCart.options.enableDrawer) {
              window.ajaxCart.openDrawer();
            }
          }
          return;
        }
        return;
      }

      try {
        const cartAddUrl = window.themeVariables?.routes?.cartAdd || '/cart/add.js';
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: formData.id,
            quantity: formData.quantity,
            selling_plan: formData.selling_plan,
            properties: formData.properties
          })
        });

        const data = await response.json();

        if (data.status) {
          const message = data.description || data.message || (window.productStrings?.addError || 'Error adding to cart');
          this.handleErrorMessage(message);
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (this.cartType === 'drawer') {
          this.openCartDrawer();
        } else {
          window.location.href = '/cart';
        }
      } catch (error) {
        this.handleErrorMessage(error.message || (window.productStrings?.unexpectedError || 'An unexpected error occurred'));
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.container.querySelector('.product-form__error-message-wrapper');
      if (this.errorMessageWrapper) {
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.style.cssText = 'display: block; visibility: visible; height: auto; opacity: 1;';
        } else {
          this.errorMessageWrapper.style.display = 'none';
        }
      }

      let qtyErrorDiv = null;

      if (this.elements && this.elements.qtyInput) {
        const qtyContainer = this.elements.qtyInput.closest('.product-qty-wrap') || this.elements.qtyInput.parentElement;
        if (qtyContainer) {
          if (qtyContainer.nextElementSibling && qtyContainer.nextElementSibling.classList.contains('quantity-error')) {
            qtyErrorDiv = qtyContainer.nextElementSibling;
          } else if (qtyContainer.parentElement) {
            qtyErrorDiv = qtyContainer.parentElement.querySelector('.quantity-error');
          }
        }
      }

      if (!qtyErrorDiv && this.container) {
        qtyErrorDiv = this.container.querySelector('.quantity-error');
      }

      if (qtyErrorDiv) {
        if (errorMessage) {
          qtyErrorDiv.textContent = errorMessage;
          qtyErrorDiv.style.cssText = 'color: #ef4444; font-size: 12px; margin-top: 5px; display: block; visibility: visible; height: auto; opacity: 1;';
        } else {
          qtyErrorDiv.textContent = '';
          qtyErrorDiv.style.display = 'none';
        }
      }

      if (errorMessage && !this.errorMessageWrapper && !qtyErrorDiv) {
        alert(errorMessage);
      }
    }

    showProductError(message) {
      this.handleErrorMessage(message);
    }

    handleVariantInputChange(input) {
      this.updateCheckedStates(input);
    }

    handleVariantDropdownChange(dropdown) {
      const group = dropdown.closest('.product-variant-group');
      const optionValueElement = group.querySelector('.option-value');
      if (optionValueElement) {
        optionValueElement.textContent = dropdown.value;
      }
    }

    updateCheckedStates(selectedInput) {
      const group = selectedInput.closest('.product-variant-group');
      const allLabelsInGroup = group.querySelectorAll('.product-variant-value-label');
      safeForEach(allLabelsInGroup, label => {
        label.classList.remove('checked');
      });

      const selectedLabel = selectedInput.closest('.product-variant-value-label');
      if (selectedLabel) {
        selectedLabel.classList.add('checked');
      }

      selectedInput.checked = true;
    }

    selectVariantOptions(variant) {
      const variantGroups = this.container.querySelectorAll('.product-variant-group');

      if (!variant || !variant.option1) {
        return;
      }

      const options = [];
      if (variant.option1) options.push(variant.option1);
      if (variant.option2) options.push(variant.option2);
      if (variant.option3) options.push(variant.option3);

      safeForEach(options, (optionValue, index) => {
        if (variantGroups[index]) {
          const radio = variantGroups[index].querySelector(`input[value="${optionValue}"]`);
          const dropdown = variantGroups[index].querySelector('.variant-dropdown');

          if (radio) {
            radio.checked = true;
            this.updateCheckedStates(radio);
          }
          if (dropdown) {
            dropdown.value = optionValue;
          }
        }
      });
    }

    initGallery(initialIndex = 0) {
      if (!this.elements.galleryContainer) return;

      const layout = this.getGalleryLayout();

      this.destroySwipers();

      if (this.elements.galleryThumbs && layout !== 'grid') {
        this.swipers.thumbs = new Swiper(this.elements.galleryThumbs, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          direction: layout === 'left' ? 'vertical' : 'horizontal',
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          breakpoints: {
            0: {
              direction: layout === 'left' ? 'horizontal' : 'horizontal',
              slidesPerView: layout === 'left' ? 4 : 6
            },
            768: {
              slidesPerView: layout === 'left' ? 3 : 6
            },
            1024: {
              slidesPerView: layout === 'left' ? 4 : 6
            }
          }
        });
      }

      if (this.elements.galleryMain && layout !== 'grid') {
        const mainConfig = {
          slidesPerView: layout === 'slideshow' ? 2.5 : 1,
          spaceBetween: layout === 'slideshow' ? 10 : 0,
          loop: false,
          watchSlidesProgress: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        };

        if (this.swipers.thumbs) {
          mainConfig.thumbs = { swiper: this.swipers.thumbs };
        }

        if (layout === 'grid') {
          mainConfig.allowTouchMove = false;
          mainConfig.simulateTouch = false;
        }

        this.swipers.main = new Swiper(this.elements.galleryMain, {
          ...mainConfig,
          initialSlide: initialIndex,
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping'
        });
        this.swipers.main.on('slideChange', () => {
          this.updateThumbnailActiveState(this.swipers.main.activeIndex);
          this.stopActiveMedia();
        });
        this.initMediaInteraction();
      }
    }

    initMediaInteraction() {
      const gallery = this.elements.galleryMain;
      if (!gallery) return;
      const swiper = this.swipers.main;

      gallery.querySelectorAll('.product-video').forEach(container => {
        const video = container.querySelector('video');
        const iframe = container.querySelector('iframe');
        const prompt = container.querySelector('.product-video-prompt');
        
        if (prompt) {
          prompt.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            container.classList.add('is-active');

            if (video) {
              video.play().catch(err => {
                 console.error("Video play failed:", err);
              });
            } else if (iframe) {
              const src = iframe.src || '';
              if (src.includes('youtube.com')) {
                iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
              } else if (src.includes('vimeo.com')) {
                iframe.contentWindow.postMessage('{"method":"play"}', '*');
              }
            }
          });
          
          if (video) {
            video.addEventListener('play', () => {
              container.classList.add('is-active');
              if (swiper) swiper.allowTouchMove = false;
            });
            video.addEventListener('pause', () => {
              if (swiper) swiper.allowTouchMove = true;
            });
            video.addEventListener('ended', () => {
               container.classList.remove('is-active');
               if (swiper) swiper.allowTouchMove = true;
            });
          }
        }
      });

      gallery.querySelectorAll('.product-model').forEach(container => {
        const model = container.querySelector('model-viewer');
        const prompt = container.querySelector('.product-model-prompt');
        const controls = container.querySelector('.product-model-controls');

        if (prompt && model) {
          prompt.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            container.classList.add('is-active');
            model.setAttribute('camera-controls', 'true');
            model.classList.add('swiper-no-swiping');
            if (model.dismissPoster) model.dismissPoster();
            if (swiper) swiper.allowTouchMove = false;
          });
        }

        if (controls && model) {
          const zoomIn = controls.querySelector('.zoom-in');
          const zoomOut = controls.querySelector('.zoom-out');
          const viewInSpace = controls.querySelector('.view-in-space');

          if (zoomIn) zoomIn.addEventListener('click', (e) => {
            e.stopPropagation();
            const fov = parseFloat(model.getAttribute('field-of-view') || '45');
            model.setAttribute('field-of-view', `${Math.max(10, fov - 10)}deg`);
          });

          if (zoomOut) zoomOut.addEventListener('click', (e) => {
            e.stopPropagation();
            const fov = parseFloat(model.getAttribute('field-of-view') || '45');
            model.setAttribute('field-of-view', `${Math.min(90, fov + 10)}deg`);
          });

          if (viewInSpace) viewInSpace.addEventListener('click', (e) => {
            e.stopPropagation();
            model.activateAR();
          });
        }
      });

      window.addEventListener('message', (event) => {
        let data;
        try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } 
        catch (e) { return; }

        if (data.event === 'infoDelivery' && data.info && data.info.playerState === 1) {
            if (swiper) swiper.allowTouchMove = false;
        } else if (data.event === 'infoDelivery' && data.info && (data.info.playerState === 2 || data.info.playerState === 0)) {
            if (swiper) swiper.allowTouchMove = true;
        }

        if (data.event === 'play' || data.method === 'play') {
          if (swiper) swiper.allowTouchMove = false;
        } else if (data.event === 'pause' || data.method === 'pause') {
          if (swiper) swiper.allowTouchMove = true;
        }
      });
    }

    stopActiveMedia() {
      const gallery = this.elements.galleryMain;
      if (!gallery) return;
      const swiper = this.swipers.main;

      if (typeof window.pauseAllMedia === 'function') {
        window.pauseAllMedia();
      }

      gallery.querySelectorAll('.product-video.is-active').forEach(c => c.classList.remove('is-active'));
      gallery.querySelectorAll('.product-model.is-active').forEach(c => {
        c.classList.remove('is-active');
        const model = c.querySelector('model-viewer');
        if (model) {
          model.removeAttribute('camera-controls');
          model.classList.remove('swiper-no-swiping');
          if (model.showPoster) model.showPoster();
        }
      });

      if (swiper) swiper.allowTouchMove = true;
    }

    getGalleryLayout() {
      if (!this.elements.galleryContainer) return 'default';

      if (this.elements.galleryContainer.classList.contains('product-gallery--grid')) return 'grid';
      if (this.elements.galleryContainer.classList.contains('slideshow-2p5')) return 'slideshow';
      if (this.elements.galleryContainer.classList.contains('product-gallery--left')) return 'left';
      if (this.elements.galleryContainer.classList.contains('product-gallery--bottom')) return 'bottom';
      return 'default';
    }

    destroySwipers() {
      if (this.swipers.main) {
        this.swipers.main.destroy(true, true);
        this.swipers.main = null;
      }
      if (this.swipers.thumbs) {
        this.swipers.thumbs.destroy(true, true);
        this.swipers.thumbs = null;
      }
    }

    updateThumbnailActiveState(activeIndex) {
      if (!this.elements.galleryThumbs) return;

      const thumbnails = this.elements.galleryThumbs.querySelectorAll('.swiper-slide');
      safeForEach(thumbnails, (thumb, index) => {
        thumb.classList.toggle('swiper-slide-thumb-active', index === activeIndex);
        const img = thumb.querySelector('img');
        if (img) img.classList.toggle('active', index === activeIndex);
      });
    }

    getvariant() {
      if (this.variants.length === 0) return null;

      const selectedOptions = [];
      const variantGroups = this.container.querySelectorAll('.product-variant-group');

      safeForEach(variantGroups, group => {
        const selectedRadio = group.querySelector('.product-variant-value-input:checked');
        const selectedDropdown = group.querySelector('.variant-dropdown');

        if (selectedRadio) {
          selectedOptions.push(selectedRadio.value.trim());
        } else if (selectedDropdown && selectedDropdown.value) {
          selectedOptions.push(selectedDropdown.value.trim());
        } else {
          selectedOptions.push(null);
        }
      });

      const filteredOptions = selectedOptions.filter(opt => opt !== null);

      if (filteredOptions.length === 0) return null;

      let variant = this.variants.find(v => {
        let matches = true;
        for (let i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] === null) continue;

          let variantOptionValue = '';
          if (i === 0) variantOptionValue = v.option1;
          else if (i === 1) variantOptionValue = v.option2;
          else if (i === 2) variantOptionValue = v.option3;

          if (!variantOptionValue || variantOptionValue.toString().trim() !== selectedOptions[i]) {
            matches = false;
            break;
          }
        }
        return matches;
      });

      if (!variant && filteredOptions.length > 0) {
        variant = this.variants.find(v => {
          return filteredOptions.every((option, index) => {
            let variantOptionValue = '';
            if (index === 0) variantOptionValue = v.option1;
            else if (index === 1) variantOptionValue = v.option2;
            else if (index === 2) variantOptionValue = v.option3;

            return variantOptionValue && variantOptionValue.toString().trim() === option;
          });
        });
      }

      return variant || null;
    }

    getVariantForGallery() {
      if (this.variant && this.variant.featured_image) {
        return this.variant;
      }
      return null;
    }

    selectDefaultVariant() {
      const availableVariant = this.variants.find(variant => variant.available);

      if (!availableVariant) {
        const firstVariant = this.variants[0];
        if (firstVariant) {
          this.selectVariantOptions(firstVariant);
          return firstVariant;
        }
        return null;
      }

      this.selectVariantOptions(availableVariant);
      return availableVariant;
    }

    updateVariantState() {
      try {
        const variant = this.getvariant();

        if (!variant && this.isInitialLoad) {
          const defaultVariant = this.selectDefaultVariant();
          this.variant = defaultVariant;
          this.isInitialLoad = false;
        } else {
          this.variant = variant;
          this.isInitialLoad = false;
        }

        const galleryVariant = this.getVariantForGallery();
        if (galleryVariant) {
          this.updateGalleryForVariant(galleryVariant);
        }

        if (this.variant) {
          const previousVariantId = this.elements.variantInput?.value;
          const variantChanged = previousVariantId != this.variant.id;

          this.updatePrice(this.variant);

          if (this.elements.inventoryEl && (variantChanged || !this.elements.inventoryEl.querySelector('.inventory-status'))) {
            this.updateInventory(this.variant);
          }

          this.updateAddToCartButton(this.variant);

          if (this.isMainProductPage) {
            this.updateURL(this.variant);
          }

          this.updateQuantityLimits(this.variant);
        } else {
          this.updateAddToCartButtonNoVariant();
          this.updateInventoryNoVariant();

          if (this.isMainProductPage) {
            this.clearURL();
          }
        }

        this.updateOptionLabels();
        this.updateVariantAvailability();
        this.updateSwatchImages();

        const variantChangedEvent = new CustomEvent('variantChanged', {
          detail: {
            variant: this.variant,
          },
        });
        document.dispatchEvent(variantChangedEvent);
      } catch (error) {
      }
    }

    updateGalleryForVariant(variant, immediate = false) {
      if (!variant?.featured_image) return;

      const targetImageSrc = this.cleanImageUrl(variant.featured_image.src);

      if (!this.swipers.main && this.elements.galleryMain) {
        this.stopActiveMedia();
        const slides = this.elements.galleryMain.querySelectorAll('.swiper-slide');

        safeForEach(slides, slide => slide.classList.remove('is-active-variant'));

        safeForEach(slides, (slide) => {
          const img = slide.querySelector('img');
          if (img) {
            const imgSrc = this.cleanImageUrl(img.src);
            if (imgSrc.includes(targetImageSrc) || targetImageSrc.includes(imgSrc)) {
              slide.classList.add('is-active-variant');
              slide.scrollIntoView({ behavior: immediate ? 'auto' : 'smooth', block: 'center' });
            }
          }
        });
        return;
      }

      if (!this.swipers.main) return;

      const slides = this.elements.galleryMain.querySelectorAll('.swiper-slide');

      let targetIndex = -1;
      safeForEach(slides, (slide, index) => {
        const img = slide.querySelector('img');
        if (img) {
          const imgSrc = this.cleanImageUrl(img.src);
          if (imgSrc.includes(targetImageSrc) || targetImageSrc.includes(imgSrc)) {
            targetIndex = index;
          }
        }
      });

      if (targetIndex >= 0 && targetIndex !== this.swipers.main.activeIndex) {
        this.swipers.main.slideTo(targetIndex, immediate ? 0 : 300);
        if (this.swipers.thumbs) {
          this.swipers.thumbs.slideTo(targetIndex, immediate ? 0 : 300);
        }
      }
    }

    cleanImageUrl(url) {
      if (!url) return '';
      return url.split('?')[0].replace(/(_\d+x\d+|_grande|_large|_medium|_small|_compact|_thumb)/g, '');
    }

    updatePrice(variant) {
      if (!variant || !this.elements.priceEl) return;

      const comparePriceContainers = this.elements.priceEl.querySelectorAll('[data-compare-price]');
      const currentPriceSpans = this.elements.priceEl.querySelectorAll('[data-current-price]');
      currentPriceSpans.forEach(span => {
        span.innerHTML = this.formatMoney(variant.price);
      });

      const comparePriceValueSpans = this.elements.priceEl.querySelectorAll('[data-compare-price-value]');

      const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (isOnSale) {
        comparePriceValueSpans.forEach(span => {
          span.innerHTML = this.formatMoney(variant.compare_at_price);
        });
        this.elements.priceEl.classList.add('price--on-sale');
      } else {
        this.elements.priceEl.classList.remove('price--on-sale');
      }
      const priceBadges = this.elements.priceEl.querySelectorAll('[data-price-badge]');

      priceBadges.forEach(priceBadge => {
        const soldOutBadges = priceBadge.querySelectorAll('[data-badge-type="sold-out"]');
        const saleBadges = priceBadge.querySelectorAll('[data-badge-type="sale"]');
        const initialSoldOutBadges = priceBadge.querySelectorAll('[data-badge-type="sold-out-initial"]');
        const initialSaleBadges = priceBadge.querySelectorAll('[data-badge-type="sale-initial"]');
        const allBadges = priceBadge.querySelectorAll('[data-badge-type]');

        allBadges.forEach(badge => {
          badge.style.display = 'none';
        });

        initialSoldOutBadges.forEach(badge => badge.remove());
        initialSaleBadges.forEach(badge => badge.remove());

        if (!variant.available) {
          if (soldOutBadges.length > 0) {
            soldOutBadges.forEach(badge => {
              badge.style.display = 'inline-block';
              this.updateBadgeColorScheme(badge);
            });
            priceBadge.style.display = 'block';
          } else {
            this.createBadge(priceBadge, 'sold-out', variant);
          }
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (saleBadges.length > 0) {
            saleBadges.forEach(badge => {
              badge.style.display = 'inline-block';
              this.updateBadgeColorScheme(badge);
            });
            priceBadge.style.display = 'block';
          } else {
            this.createBadge(priceBadge, 'sale', variant);
          }
        } else {
          priceBadge.style.display = 'none';
        }
      });

      const unitPriceEls = this.elements.priceEl.querySelectorAll('[data-unit-price]');
      unitPriceEls.forEach(unitPriceEl => {
        if (variant.unit_price) {
          const unitPriceItem = unitPriceEl.querySelector('.price-item--last');
          if (unitPriceItem) {
            const spans = unitPriceItem.querySelectorAll('span:not(.visually-hidden):not([aria-hidden])');
            if (spans.length >= 2) {
              spans[0].innerHTML = this.formatMoney(variant.unit_price);
              const refValue = variant.unit_price_measurement.reference_value !== 1 ? variant.unit_price_measurement.reference_value : '';
              spans[1].innerHTML = `${refValue}${variant.unit_price_measurement.reference_unit}`;
            }
          }
          unitPriceEl.classList.remove('hide');
        } else {
          unitPriceEl.classList.add('hide');
        }
      });
    }

    createBadge(container, badgeType, variant) {
      const badgeText = badgeType === 'sold-out' ?
        (window.translations?.products?.product?.sold_out || 'Sold Out') :
        (window.translations?.products?.product?.on_sale || 'Sale');

      const colorScheme = badgeType === 'sold-out' ?
        (window.themeVariables?.settings?.sold_out_badge_color_scheme || 'scheme-4') :
        (window.themeVariables?.settings?.sale_badge_color_scheme || 'scheme-4');

      const badge = document.createElement('span');
      badge.className = `badge color-${colorScheme}`;
      badge.setAttribute('data-badge-type', badgeType);
      badge.setAttribute('data-badge-scheme', colorScheme);
      badge.textContent = badgeText;
      badge.style.display = 'inline-block';

      container.appendChild(badge);
      container.style.display = 'block';

      return badge;
    }

    updateBadgeColorScheme(badgeElement) {
      if (!badgeElement) return;

      const colorScheme = badgeElement.dataset.badgeScheme || 'scheme-4';

      badgeElement.classList.remove('color-scheme-1', 'color-scheme-2', 'color-scheme-3', 'color-scheme-4');

      badgeElement.classList.add(`color-${colorScheme}`);
    }

    updatePriceForNoVariants() {
      if (!this.elements.priceEl) return;

      let price, compareAtPrice, available;

      const productDataScript = this.container.querySelector('[id^="product-variants-json"]');
      if (productDataScript) {
        try {
          const productData = JSON.parse(productDataScript.textContent);
          if (productData.length > 0) {
            price = productData[0].price;
            compareAtPrice = productData[0].compare_at_price;
            available = productData[0].available;
          }
        } catch (e) {
        }
      }

      if ((price === undefined || price === null) && window.productData) {
        price = window.productData.price;
        compareAtPrice = window.productData.compare_at_price;
        available = window.productData.available;
      }

    }

    updateSKU(variant) {
      const skuElement = this.container.querySelector('[id^="sku-"]');
      if (!skuElement) return;

      if (variant && variant.sku && variant.sku.length > 0) {
        skuElement.textContent = variant.sku;
        skuElement.classList.remove('hidden');
      } else {
        skuElement.textContent = '';
        skuElement.classList.add('hidden');
      }
    }

    updateInventory(variant) {
      if (!this.elements.inventoryEl) return;

      if (!variant) {
        this.updateInventoryNoVariant();
        return;
      }

      const threshold = parseInt(this.elements.inventoryEl.dataset.inventoryThreshold) || 10;
      const showQuantity = this.elements.inventoryEl.dataset.showInventoryQuantity === 'true';
      const inStockText = this.elements.inventoryEl.dataset.inStockText || window.productStrings?.inStock || 'In stock';
      const lowStockText = this.elements.inventoryEl.dataset.lowStockText || window.productStrings?.lowStock || 'Low stock';
      const outOfStockText = this.elements.inventoryEl.dataset.outOfStockText || window.productStrings?.outOfStock || 'Out of stock';

      let statusClass = '';
      let statusText = '';

      const inventoryQty = variant.inventory_quantity;
      const hasInventoryTracking = variant.inventory_management === 'shopify' && inventoryQty !== null && inventoryQty !== undefined;

      if (!variant.available) {
        statusClass = 'sold-out';
        statusText = outOfStockText;
      } else if (hasInventoryTracking) {
        const qty = parseInt(inventoryQty);

        if (isNaN(qty) || qty <= 0) {
          statusClass = 'sold-out';
          statusText = outOfStockText;
        } else if (qty <= threshold) {
          statusClass = 'low-stock';
          statusText = showQuantity ? `${lowStockText} (${qty})` : lowStockText;
        } else {
          statusClass = 'available';
          statusText = showQuantity ? `${inStockText} (${qty})` : inStockText;
        }
      } else {
        statusClass = 'available';
        statusText = inStockText;
      }

      const currentContent = this.elements.inventoryEl.querySelector('.inventory-status');
      const newContent = `<span class="inventory-status ${statusClass}">${statusText}</span>`;

      if (!currentContent || currentContent.outerHTML !== newContent) {
        this.elements.inventoryEl.innerHTML = newContent;
      }

      this.elements.inventoryEl.dataset.currentInventory = inventoryQty !== null && inventoryQty !== undefined ? inventoryQty : '';
      this.elements.inventoryEl.dataset.currentAvailable = variant.available;
      this.elements.inventoryEl.dataset.currentInventoryManagement = variant.inventory_management || '';
    }

    updateInventoryForNoVariants() {
      if (!this.elements.inventoryEl) return;

      const existingStatus = this.elements.inventoryEl.querySelector('.inventory-status');
      if (existingStatus && existingStatus.textContent.trim() !== '' && !existingStatus.textContent.includes('undefined')) {
        return;
      }

      const threshold = parseInt(this.elements.inventoryEl.dataset.inventoryThreshold) || 10;
      const showQuantity = this.elements.inventoryEl.dataset.showInventoryQuantity === 'true';
      let inventoryQuantity = this.elements.inventoryEl.dataset.currentInventory;
      let available = this.elements.inventoryEl.dataset.currentAvailable;
      let inventoryManagement = this.elements.inventoryEl.dataset.currentInventoryManagement;

      if (inventoryQuantity !== undefined && inventoryQuantity !== 'null' && inventoryQuantity !== '') {
        inventoryQuantity = parseInt(inventoryQuantity);
      } else {
        inventoryQuantity = null;
      }

      if (available !== undefined && available !== 'null' && available !== '') {
        available = available === 'true';
      } else {
        available = true;
      }

      if (inventoryQuantity === null || isNaN(inventoryQuantity)) {
        const productDataScript = this.container.querySelector('#product-variants-json');
        if (productDataScript) {
          try {
            const productData = JSON.parse(productDataScript.textContent);
            if (productData.length > 0) {
              inventoryQuantity = productData[0].inventory_quantity;
              available = productData[0].available;
              inventoryManagement = productData[0].inventory_management;
            }
          } catch (e) {
          }
        }
      }

      if ((inventoryQuantity === null || isNaN(inventoryQuantity)) && window.productData) {
        inventoryQuantity = window.productData.inventory_quantity;
        available = window.productData.available;
        inventoryManagement = window.productData.inventory_management;
      }

      let statusClass = '';
      let statusText = '';

      if (!available) {
        statusClass = 'sold-out';
        statusText = 'Out of stock';
      } else if (inventoryManagement === 'shopify' && inventoryQuantity !== null && !isNaN(inventoryQuantity)) {
        const qty = parseInt(inventoryQuantity);
        if (qty <= 0) {
          statusClass = 'sold-out';
          statusText = 'Out of stock';
        } else if (qty <= threshold) {
          statusClass = 'low-stock';
          statusText = showQuantity ? `Low stock (${qty} left)` : 'Low stock';
        } else {
          statusClass = 'available';
          statusText = showQuantity ? `In stock (${qty})` : 'In stock';
        }
      } else {
        statusClass = 'available';
        statusText = 'In stock';
      }

      this.elements.inventoryEl.innerHTML = `<span class="inventory-status ${statusClass}">${statusText}</span>`;
    }

    updateInventoryNoVariant() {
      if (!this.elements.inventoryEl) return;
      const unavailableText = this.elements.inventoryEl.dataset.unavailableText || 'Unavailable';
      this.elements.inventoryEl.innerHTML = `<span class="inventory-status unavailable">${unavailableText}</span>`;
    }

    updateAddToCartButton(variant) {
      if (!this.elements.addToCartBtn) return;

      this.elements.addToCartBtn.classList.remove('sold-out', 'unavailable', 'loading');
      this.elements.addToCartBtn.disabled = false;

      if (!variant.available) {
        this.elements.addToCartBtn.classList.add('sold-out');
        this.elements.addToCartBtn.disabled = true;
        this.elements.addToCartBtn.textContent = window.productStrings?.soldOut || 'Sold Out';
      } else {
        this.elements.addToCartBtn.classList.remove('sold-out', 'unavailable');
        this.elements.addToCartBtn.textContent = window.productStrings?.addToCart || 'Add to Cart';
        this.elements.addToCartBtn.disabled = false;
      }

      if (this.elements.variantInput) {
        this.elements.variantInput.value = variant.id;
        this.elements.variantInput.dataset.requiresSellingPlan = variant.requires_selling_plan;
      }
    }

    updateAddToCartButtonNoVariant() {
      if (!this.elements.addToCartBtn) return;

      this.elements.addToCartBtn.classList.remove('sold-out', 'loading');
      this.elements.addToCartBtn.classList.add('unavailable');
      this.elements.addToCartBtn.disabled = true;
      this.elements.addToCartBtn.textContent = window.productStrings?.unavailable || 'Unavailable';

      if (this.elements.variantInput) {
        this.elements.variantInput.value = '';
      }
    }

    updateOptionLabels() {
      const variantGroups = this.container.querySelectorAll('.product-variant-group');
      safeForEach(variantGroups, group => {
        const selectedRadio = group.querySelector('input[type="radio"]:checked');
        const selectedDropdown = group.querySelector('.variant-dropdown');
        const optionValueElement = group.querySelector('.option-value');

        if (optionValueElement) {
          if (selectedRadio) {
            optionValueElement.textContent = selectedRadio.value;
          } else if (selectedDropdown) {
            optionValueElement.textContent = selectedDropdown.value;
          }
        }
      });
    }

    updateSwatchImages() {
      const variantGroups = this.container.querySelectorAll('.product-variant-group');
      const selectedOptions = [];
      safeForEach(variantGroups, group => {
        const selectedRadio = group.querySelector('.product-variant-value-input:checked');
        const selectedDropdown = group.querySelector('.variant-dropdown');
        if (selectedRadio) selectedOptions.push(selectedRadio.value.trim());
        else if (selectedDropdown && selectedDropdown.value) selectedOptions.push(selectedDropdown.value.trim());
        else selectedOptions.push(null);
      });

      safeForEach(variantGroups, (group, groupIndex) => {
        const inputs = group.querySelectorAll('input[type="radio"]');
        safeForEach(inputs, input => {
          const label = input.closest('.product-variant-value-label');
          if (!label) return;
          const imageSpan = label.querySelector('.variant-color-image');

          if (imageSpan) {
            if (imageSpan.dataset.isCustomSwatch === 'true') return;

            const hypotheticalSelections = [...selectedOptions];
            hypotheticalSelections[groupIndex] = input.value.trim();

            const variant = this.getMatchVariant(hypotheticalSelections);

            if (variant && variant.featured_image && variant.featured_image.src) {
              const newUrl = this.getResizedImage(variant.featured_image.src, '100x');
              imageSpan.style.backgroundImage = `url('${newUrl}')`;
            }
          }
        });
      });
    }

    getMatchVariant(options) {
      return this.variants.find(v => {
        let matches = true;
        for (let i = 0; i < options.length; i++) {
          if (options[i] === null) continue;
          let variantOptionValue = '';
          if (i === 0) variantOptionValue = v.option1;
          else if (i === 1) variantOptionValue = v.option2;
          else if (i === 2) variantOptionValue = v.option3;
          if (!variantOptionValue || variantOptionValue.toString().trim() !== options[i]) {
            matches = false;
            break;
          }
        }
        return matches;
      });
    }

    getResizedImage(url, size) {
      if (!url) return '';
      const clean = this.cleanImageUrl(url);
      const idx = clean.lastIndexOf('.');
      if (idx === -1) return clean;
      return clean.substring(0, idx) + '_' + size + clean.substring(idx);
    }

    updateURL(variant) {
      if (!variant) return;

      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    clearURL() {
      const url = new URL(window.location);
      url.searchParams.delete('variant');
      window.history.replaceState({}, '', url.toString());
    }

    updateQuantityLimits(variant) {
      if (!this.elements.qtyInput || !variant) return;

      this.elements.qtyInput.dataset.variantId = variant.id;

      let maxQuantity = 99999;

      if (variant.inventory_management && variant.inventory_policy === 'deny') {
        maxQuantity = (variant.inventory_quantity !== null && variant.inventory_quantity > 0) ? variant.inventory_quantity : 0;
      }

      if (variant.max_purchase_quantity && variant.max_purchase_quantity > 0) {
        maxQuantity = Math.min(maxQuantity, variant.max_purchase_quantity);
      }

      this.elements.qtyInput.setAttribute('max', maxQuantity);

      const minQuantity = (variant.min_purchase_quantity && variant.min_purchase_quantity > 0) ? variant.min_purchase_quantity : 1;
      this.elements.qtyInput.setAttribute('min', minQuantity);

      const currentValue = parseInt(this.elements.qtyInput.value);
      if (currentValue > maxQuantity && maxQuantity > 0) {
        this.elements.qtyInput.value = maxQuantity;
      } else if (currentValue < minQuantity) {
        this.elements.qtyInput.value = minQuantity;
      }
    }

    updateVariantAvailability() {
      try {
        const variantLabels = this.container.querySelectorAll('.product-variant-value-label');
        safeForEach(variantLabels, label => {
          label.classList.remove('variant-option-unavailable', 'soldout', 'unavailable');
          const input = label.querySelector('input');
          if (input) input.disabled = false;
        });

        const currentSelections = [];
        const variantGroups = this.container.querySelectorAll('.product-variant-group');

        safeForEach(variantGroups, group => {
          const selectedRadio = group.querySelector('input[type="radio"]:checked');
          const selectedDropdown = group.querySelector('.variant-dropdown');

          if (selectedRadio) {
            currentSelections.push(selectedRadio.value.trim());
          } else if (selectedDropdown && selectedDropdown.value) {
            currentSelections.push(selectedDropdown.value.trim());
          } else {
            currentSelections.push(null);
          }
        });

        safeForEach(variantGroups, (group, groupIndex) => {
          const inputs = group.querySelectorAll('input[type="radio"]');

          safeForEach(inputs, input => {
            try {
              const label = input.closest('.product-variant-value-label');
              const testSelections = [...currentSelections];
              testSelections[groupIndex] = input.value.trim();

              const matchingVariant = this.variants.find(variant => {
                let matches = true;
                for (let i = 0; i < testSelections.length; i++) {
                  if (testSelections[i] === null) continue;

                  let variantOptionValue = '';
                  if (i === 0) variantOptionValue = variant.option1;
                  else if (i === 1) variantOptionValue = variant.option2;
                  else if (i === 2) variantOptionValue = variant.option3;

                  if (!variantOptionValue || variantOptionValue.toString().trim() !== testSelections[i]) {
                    matches = false;
                    break;
                  }
                }
                return matches;
              });

              if (groupIndex === 0) {
                input.disabled = false;

                const firstOptionVariants = this.variants.filter(v =>
                  v.option1 && v.option1.trim() === input.value.trim()
                );

                if (firstOptionVariants.length > 0 && firstOptionVariants.every(v => !v.available)) {
                  label.classList.add('soldout');
                }
              }
              else {
                input.disabled = false;

                if (!matchingVariant) {
                  label.classList.add('variant-option-unavailable', 'unavailable');
                } else if (!matchingVariant.available) {
                  label.classList.add('variant-option-unavailable', 'soldout');
                }
              }
            } catch (error) {
            }
          });
        });
      } catch (error) {
      }
    }

    setupQuantityControls() {
      const minusBtn = this.container.querySelector('.product-qty-minus-btn');
      const plusBtn = this.container.querySelector('.product-qty-plus-btn');
      const qtyInput = this.elements.qtyInput;

      if (minusBtn && qtyInput) {
        minusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const minQuantity = parseInt(qtyInput.getAttribute('min')) || 1;
          const currentValue = parseInt(qtyInput.value) || minQuantity;

          if (currentValue > minQuantity) {
            qtyInput.value = currentValue - 1;
            qtyInput.dispatchEvent(new Event('change'));
          }
        });
      }

      if (plusBtn && qtyInput) {
        plusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const minQuantity = parseInt(qtyInput.getAttribute('min')) || 1;
          const currentValue = parseInt(qtyInput.value) || minQuantity;
          const maxValue = parseInt(qtyInput.getAttribute('max')) || 99999;

          if (currentValue >= maxValue) {
            const message = window.ajaxCart?.lastInventoryErrorMessage || '';
            if (message) {
              this.showProductError(message);
            }
            return;
          }

          qtyInput.value = currentValue + 1;
          qtyInput.dispatchEvent(new Event('change'));
        });
      }

      if (qtyInput) {
        qtyInput.addEventListener('input', () => {
          const value = qtyInput.value;
          if (value.startsWith('-')) {
            qtyInput.value = value.replace('-', '');
          }
        });

        const validate = () => {
          const value = parseInt(qtyInput.value);
          const minQuantity = parseInt(qtyInput.getAttribute('min')) || 1;
          const maxValue = parseInt(qtyInput.getAttribute('max')) || 99999;

          if (isNaN(value) || value < minQuantity) {
            qtyInput.value = minQuantity;
          } else if (value > maxValue) {
            qtyInput.value = maxValue;
          }
        };

        qtyInput.addEventListener('blur', validate);
        qtyInput.addEventListener('change', validate);
      }
    }

    loadVariantFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');

      if (!variantId) return;

      const variant = this.variants.find(v => v.id == variantId);
      if (!variant) return;

      this.selectVariantOptions(variant);
      this.variant = variant;

      this.updatePrice(variant);
      this.updateInventory(variant);
      this.updateAddToCartButton(variant);
    }

    formatMoney(cents, useCurrencyCode = false) {
      if (typeof cents === 'string') {
        cents = cents.replace(/[.,]/g, '');
        cents = parseInt(cents);
      }

      if (isNaN(cents) || cents === null || cents === undefined) {
        cents = 0;
      }

      let moneyFormat;
      if (useCurrencyCode || window.themeVariables?.settings?.currencyCodeEnabled) {
        moneyFormat = window.themeVariables?.settings?.moneyWithCurrencyFormat;
      } else {
        moneyFormat = window.themeVariables?.settings?.moneyFormat;
      }

      if (!moneyFormat) {
        moneyFormat = '{{amount}}';
      }

      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents, moneyFormat);
      }

      const amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{.*?\}\}/, amount);
    }

    initZoom() {
      const zoomContainers = this.container.querySelectorAll('.zoom');
      zoomContainers.forEach(container => {
        const zoomUrl = container.dataset.zoomUrl;
        
        const loadZoomImage = () => {
          if (zoomUrl && !container.style.backgroundImage) {
            container.style.backgroundImage = `url(${zoomUrl})`;
          }
        };

        const handleZoom = (e) => {
          loadZoomImage();
          const rect = container.getBoundingClientRect();
          let x, y;

          if (e.touches && e.touches.length > 0) {
            const touch = e.touches[0];
            x = ((touch.clientX - rect.left) / rect.width) * 100;
            y = ((touch.clientY - rect.top) / rect.height) * 100;
          } else {
            x = ((e.clientX - rect.left) / rect.width) * 100;
            y = ((e.clientY - rect.top) / rect.height) * 100;
          }

          x = Math.max(0, Math.min(100, x));
          y = Math.max(0, Math.min(100, y));

          container.style.backgroundPosition = `${x}% ${y}%`;
        };

        container.addEventListener('mouseenter', loadZoomImage, { once: true });
        container.addEventListener('touchstart', loadZoomImage, { passive: true, once: true });
        container.addEventListener('mousemove', handleZoom);
        container.addEventListener('touchmove', handleZoom, { passive: true });
      });
    }

    destroy() {
      if (this.boundHandleChange) {
        this.container.removeEventListener('change', this.boundHandleChange);
      }
      if (this.boundHandleClick) {
        this.container.removeEventListener('click', this.boundHandleClick);
      }
      if (this.boundHandleSubmit && this.elements.form) {
        this.elements.form.removeEventListener('submit', this.boundHandleSubmit);
      }

      this.destroySwipers();
    }
  }

  window.ShopifyProductManager = ShopifyProductManager;

  document.addEventListener('DOMContentLoaded', () => {
    const mainProductContainers = document.querySelectorAll('.main-product-section, [data-section-type="product"]');

    if (mainProductContainers.length > 0) {
      mainProductContainers.forEach(container => {
        if (!container.dataset.productManagerInit) {
          container.dataset.productManagerInit = 'true';
          container.productManagerInstance = new ShopifyProductManager(container);
        }
      });
    } else {
      const docManager = new ShopifyProductManager(document);
      document.productManagerInstance = docManager;
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.main-product-section, [data-section-type="product"]');
    if (container) {
      if (container.productManagerInstance) {
        container.productManagerInstance.destroy();
      }
      container.dataset.productManagerInit = 'true';
      container.productManagerInstance = new ShopifyProductManager(container);
    }
  });

  if (!customElements.get('recipient-form')) {
    customElements.define('recipient-form', class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.fieldsContainer = this.querySelector('[data-recipient-fields]');
        this.emailInput = this.querySelector('[data-recipient-email]');
        this.form = this.closest('form');

        if (this.checkbox) {
          this.checkbox.addEventListener('change', () => this.toggleFields());
          this.toggleFields();
        }

        if (this.form) {
          this.form.addEventListener('submit', (e) => this.validateForm(e));
        }

        this.addEventListener('input', (e) => {
          if (e.target.hasAttribute('data-recipient-email') || e.target.hasAttribute('data-recipient-send-on')) {
            this.clearFieldError(e.target);
          }
        });

        this.addEventListener('change', (e) => {
          if (e.target.hasAttribute('data-recipient-email') || e.target.hasAttribute('data-recipient-send-on')) {
            this.checkValidation(false);
          }
        });
      }

      toggleFields() {
        if (this.checkbox.checked) {
          this.fieldsContainer.style.display = 'grid';
          this.enableInputs();
          if (this.emailInput) {
            this.emailInput.setAttribute('required', 'required');
          }
        } else {
          this.fieldsContainer.style.display = 'none';
          this.disableInputs();
          this.clearErrors();
          if (this.emailInput) {
            this.emailInput.removeAttribute('required');
          }
        }
      }

      checkValidation(scrollTo = true) {
        const errors = [];

        if (!this.checkbox.checked) {
          this.clearErrors();
          const controlInput = this.querySelector('#Recipient-Control-' + this.dataset.sectionId);
          if (controlInput) {
            controlInput.value = '';
          }
          return true;
        }

        const emailValue = this.emailInput?.value?.trim() || '';

        if (!emailValue) {
          errors.push({ field: 'email', message: this.getTranslation('email_required', 'Email is required') });
        } else {
          const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
          if (!emailRegex.test(emailValue)) {
            errors.push({ field: 'email', message: this.getTranslation('email_invalid', 'Email is invalid') });
          }
        }

        const sendOnInput = this.querySelector('[data-recipient-send-on]');
        if (sendOnInput && sendOnInput.value) {
          const sendDate = new Date(sendOnInput.value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          if (sendDate < today) {
            errors.push({ field: 'send_on', message: this.getTranslation('date_past', 'Send date cannot be in the past') });
          } else {
            const maxDate = new Date();
            maxDate.setDate(maxDate.getDate() + 90);
            maxDate.setHours(23, 59, 59, 999);
            if (sendDate > maxDate) {
              errors.push({ field: 'send_on', message: this.getTranslation('date_future', 'Send on must be within 90 days from now') });
            }
          }
        }

        if (errors.length > 0) {
          this.displayErrors(errors, scrollTo);
          return false;
        }

        this.clearErrors();
        return true;
      }

      validateForm(e) {
        const isValid = this.checkValidation(true);
        if (!isValid && e) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
        return isValid;
      }

      getTranslation(key, fallback) {
        const translations = {
          email_required: this.dataset.emailRequiredText,
          email_invalid: this.dataset.emailInvalidText,
          date_past: this.dataset.datePastText,
          date_future: this.dataset.dateFutureText
        };
        return translations[key] || fallback;
      }

      displayErrors(errors, scrollTo = true) {
        const errorWrapper = this.querySelector('.product-form-recipient-error-message-wrapper');
        const summaryList = errorWrapper?.querySelector('ul');

        if (errorWrapper && summaryList) {
          errorWrapper.removeAttribute('hidden');
          summaryList.classList.remove('hidden');
          summaryList.innerHTML = '';
          errors.forEach(error => {
            const li = document.createElement('li');
            const link = document.createElement('a');
            const fieldId = `Recipient-${error.field === 'send_on' ? 'send-on' : error.field}-${this.dataset.sectionId}`;
            link.href = `#${fieldId}`;
            link.textContent = error.message;
            link.className = 'link';

            li.appendChild(link);
            summaryList.appendChild(li);
            this.showFieldError(error.field, error.message);
          });
          if (scrollTo) {
            errorWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }

      clearFieldError(input) {
        input.classList.remove('error');
        input.removeAttribute('aria-invalid');

        let field = '';
        if (input.hasAttribute('data-recipient-email')) field = 'email';
        if (input.hasAttribute('data-recipient-send-on')) field = 'send_on';

        if (field) {
          const fieldName = field.replace('_', '-');
          const errorDiv = this.querySelector(`#RecipientForm-${fieldName}-error-${this.dataset.sectionId}`);
          if (errorDiv) errorDiv.classList.add('hidden');
        }

        const remainingErrors = this.querySelectorAll('.field-input.error');
        if (remainingErrors.length === 0) {
          const errorWrapper = this.querySelector('.product-form-recipient-error-message-wrapper');
          if (errorWrapper) errorWrapper.setAttribute('hidden', '');
        }
      }

      showFieldError(field, message) {
        const fieldName = field.replace('_', '-');
        const errorDiv = this.querySelector(`#RecipientForm-${fieldName}-error-${this.dataset.sectionId}`);
        if (errorDiv) {
          errorDiv.classList.remove('hidden');
          const msgSpan = errorDiv.querySelector('.error-message');
          if (msgSpan) {
            msgSpan.textContent = message.endsWith('.') ? message : `${message}.`;
          }
        }

        const inputSelector = field === 'send_on' ? '[name="properties[Send on]"]' : `[name="properties[Recipient ${field}]"]`;
        const input = this.querySelector(inputSelector) || this.querySelector(`[data-recipient-${field.replace('_', '-')}]`);

        if (input) {
          input.classList.add('error');
          input.setAttribute('aria-invalid', 'true');
        }
      }

      enableInputs() {
        if (!this.fieldsContainer) return;
        const inputs = this.fieldsContainer.querySelectorAll('input, textarea');
        inputs.forEach(input => {
          input.removeAttribute('disabled');
        });
      }

      disableInputs() {
        if (!this.fieldsContainer) return;
        const inputs = this.fieldsContainer.querySelectorAll('input, textarea');
        inputs.forEach(input => {
          input.setAttribute('disabled', 'disabled');
          input.value = '';
          input.classList.remove('error');
          input.removeAttribute('aria-invalid');
        });
      }

      clearErrors() {
        const errorWrapper = this.querySelector('.product-form-recipient-error-message-wrapper');
        if (errorWrapper) {
          errorWrapper.setAttribute('hidden', '');
        }
        const errorMessages = this.querySelectorAll('.form-message');
        errorMessages.forEach(msg => {
          msg.classList.add('hidden');
        });

        const inputs = this.querySelectorAll('input, textarea');
        inputs.forEach(input => {
          input.classList.remove('error');
          input.removeAttribute('aria-invalid');
        });
      }
    });
  }
}

/* size chart start */

class SizeChartPopup {
  constructor() {
    this.sizeChartBtn = document.querySelector('.product-size-chart-btn-text');
    this.sizeChartPopup = document.querySelector('.product-size-chart-drawer');
    this.sizeChartClose = document.querySelector('.product-size-chart-close');
    this.sizeChartContent = document.querySelector('.product-size-chart-drawer-content');
    this.body = document.body;
    this.mainProductSection = document.querySelector('.main-product-section');

    if (this.sizeChartBtn && this.sizeChartPopup && this.sizeChartClose && this.sizeChartContent) {
      this.init();
    }
  }

  init() {
    this.sizeChartBtn.addEventListener('click', this.openPopup.bind(this));
    this.sizeChartClose.addEventListener('click', this.closePopup.bind(this));

    this.sizeChartPopup.addEventListener('click', (e) => {
      if (e.target === this.sizeChartPopup) {
        this.closePopup(e);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.sizeChartPopup.classList.contains('show')) {
        this.closePopup(e);
      }
    });
  }

  openPopup(event) {
    event.preventDefault();
    event.stopPropagation();
    this.sizeChartPopup.classList.add('show');
    this.body.classList.add('no-scroll');
    this.togglePopupOverlay(true);
  }

  closePopup(event) {
    event.preventDefault();
    event.stopPropagation();
    this.sizeChartPopup.classList.remove('show');
    this.body.classList.remove('no-scroll');
    this.togglePopupOverlay(false);
  }

  togglePopupOverlay(isOpen) {
    if (this.mainProductSection) {
      if (isOpen) {
        this.mainProductSection.classList.add('popup-overlay');
      } else {
        this.mainProductSection.classList.remove('popup-overlay');
      }
    }
  }
}

/* size chart end */

/* product lightbox start */

class ProductLightbox {
  constructor() {
    this.modal = document.getElementById('product-image-modal');
    if (!this.modal) return;

    this.container = document.querySelector('.product-gallery__main');
    this.lightboxMediaItems = this.modal.querySelectorAll('.lightbox-media-item');
    this.overlay = this.modal.querySelector('.lightbox-overlay');
    this.closeBtn = this.modal.querySelector('.lightbox-close');
    this.prevBtn = this.modal.querySelector('.lightbox-prev');
    this.nextBtn = this.modal.querySelector('.lightbox-next');
    this.currentIndex = 0;

    this.init();
  }

  init() {
    const galleryItems = document.querySelectorAll('.product-gallery__main .zoom, .product-gallery__main .product-image');
    galleryItems.forEach((item, index) => {
      item.style.cursor = 'zoom-in';
      item.addEventListener('click', (e) => {
        const slide = item.closest('.swiper-slide');
        if (slide) {
          const slides = Array.from(slide.parentElement.children);
          const idx = slides.indexOf(slide);
          this.openModal(idx >= 0 ? idx : 0);
        }
      });
    });

    this.overlay.addEventListener('click', () => this.closeModal());
    this.closeBtn.addEventListener('click', () => this.closeModal());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.showNext());
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.showPrev());

    document.addEventListener('keydown', e => {
      if (this.modal.style.display !== 'flex') return;
      if (e.key === 'ArrowRight') this.showNext();
      if (e.key === 'ArrowLeft') this.showPrev();
      if (e.key === 'Escape') this.closeModal();
    });

    this.setupTouch();
  }

  showImage(index) {
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    this.lightboxMediaItems.forEach(item => {
      item.style.display = 'none';
      item.style.opacity = '0';
    });
    
    const targetItem = document.getElementById(`lightbox-media-${index}`);
    if (targetItem) {
      targetItem.style.display = 'flex';
      setTimeout(() => { targetItem.style.opacity = '1'; }, 10);
    }
    this.currentIndex = index;
  }

  openModal(index) {
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    this.currentIndex = index;
    this.modal.style.display = 'flex';
    document.body.classList.add('no-scroll');
    document.body.classList.add('modal-open');
    this.showImage(this.currentIndex);
  }

  closeModal() {
    this.modal.style.display = 'none';
    document.body.classList.remove('no-scroll');
    document.body.classList.remove('modal-open');
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
  }

  showNext() {
    this.currentIndex = (this.currentIndex + 1) % this.lightboxMediaItems.length;
    this.showImage(this.currentIndex);
  }

  showPrev() {
    this.currentIndex = (this.currentIndex - 1 + this.lightboxMediaItems.length) % this.lightboxMediaItems.length;
    this.showImage(this.currentIndex);
  }

  setupTouch() {
    let startX = 0;
    let endX = 0;

    this.modal.addEventListener('touchstart', (e) => {
      if (e.target.closest('model-viewer')) return; 
      startX = e.touches[0].clientX;
    }, { passive: true });

    this.modal.addEventListener('touchmove', (e) => {
      if (e.target.closest('model-viewer')) return;
      endX = e.touches[0].clientX;
    }, { passive: true });

    this.modal.addEventListener('touchend', (e) => {
      if (e.target.closest('model-viewer')) return;
      const diff = startX - endX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.showNext();
        else this.showPrev();
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new SizeChartPopup();
  new ProductLightbox();
});

document.addEventListener('shopify:section:load', () => {
  new SizeChartPopup();
  new ProductLightbox();
});
/* product lightbox end */